import { render, staticRenderFns } from "./Analytics.vue?vue&type=template&id=2b4d8667&scoped=true&"
import script from "./Analytics.vue?vue&type=script&lang=js&"
export * from "./Analytics.vue?vue&type=script&lang=js&"
import style0 from "./Analytics.vue?vue&type=style&index=0&id=2b4d8667&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4d8667",
  null
  
)

export default component.exports